import { useStaticQuery, graphql } from 'gatsby';

const useCaseStudies = () => {
  const data = useStaticQuery(graphql`
    query useCaseStudiesQuery {
      allSanityCaseStudy {
        nodes {
          title
          tags {
            title
          }
          image {
            alt
            asset {
              url
              gatsbyImageData(placeholder: BLURRED, formats: WEBP)
            }
          }
          service
          location
          _rawDescription(resolveReferences: { maxDepth: 10 })
          _rawProblem(resolveReferences: { maxDepth: 10 })
          _rawSolution(resolveReferences: { maxDepth: 10 })
          internalLink {
            slug {
              current
            }
          }
        }
      }
    }
  `);

  const caseStudies = data.allSanityCaseStudy.nodes;

  return caseStudies;
};

export { useCaseStudies };
